<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="formRef"
    label-width="140px"
    class="detail-form"
  >
    <el-form-item label="开发者名称" prop="developerName">
      <el-input
        size="small"
        :maxlength="64"
        show-word-limit
        v-model="formData.developerName"
        placeholder="请输入开发者名称"
      ></el-input>
    </el-form-item>

    <el-form-item label="商务对接人" prop="businessName">
      <el-select
        size="small"
        filterable
        v-model="formData.businessName"
        placeholder="请选择商务对接人"
      >
        <el-option
          v-for="item in businessNameList"
          :key="item.id"
          :value="item.name"
          :label="item.name"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="合作状态" prop="status" required>
      <el-switch
        v-model="formData.status"
        :active-value="1"
        :inactive-value="2"
      ></el-switch>
    </el-form-item>
    <el-form-item>
      <el-button size="small" type="primary" @click="handleSubmit()"
        >确认</el-button
      >
      <el-button size="small" @click="handleCancel()">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
export default {
  props: {
    businessNameList: {
      type: Array,
      default() {
        return [];
      },
    },
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formData: {
        developerName: "",
        businessName: "",
        status: 1,
      },
      rules: {
        developerName: [
          { required: true, message: "请输入开发者名称", trigger: "change" },
        ],
        businessName: [
          { required: true, message: "请选择商务对接人", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.initFormData(); // 初始化赋值
  },
  methods: {
    initFormData() {
      // 浅拷贝并过滤无效属性（可选）
      this.formData = {
        ...this.formData,
        ...this.detailData,
      };
      this.$refs.formRef.clearValidate(); // 清除验证状态
    },
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData);
        } else {
          this.$message.error("请检查输入的数据");
        }
      });
    },
    handleCancel() {
      this.$emit("cancle");
    },
    // 暴露给父组件调用刷新数据
    resetFields() {
      this.$refs.formRef.resetFields();
    },
  },
};
</script>
